var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4821"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631384",
    x: 0.923218,
    y: 1.37244,
    width: 6.1533,
    height: 6.1533,
    stroke: "#00C2FF",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631386",
    x: 0.923218,
    y: 10.4741,
    width: 6.1533,
    height: 6.1533,
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631385",
    x: 10.2386,
    y: 1.37231,
    width: 6.1533,
    height: 6.1533,
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631387",
    x: 10.2386,
    y: 10.4741,
    width: 6.1533,
    height: 6.1533,
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock20);
export default __webpack_public_path__ + "static/media/block_20.7d3a83e418607ff932b3f1a894a5cfb7.svg";
export { ForwardRef as ReactComponent };